import { Page, PageBody, PageContent } from "@corpuscomplete/web/components/layout";
import { ListComponent } from "../components/list";

export function ListPage({ id }: { id: string }) {
  return (
    <Page>
      <PageBody>
        <ListComponent.DataProvider listId={id}>
          <ListComponent.StoreProvider>
            <ListComponent.Header />
            <PageContent>
              <ListComponent.Content />
            </PageContent>
          </ListComponent.StoreProvider>
        </ListComponent.DataProvider>
      </PageBody>
    </Page>
  );
}
